import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import classes from './SingleLesson.module.css'
import { isJson } from '../../../../utils'
import { useNavigate } from "react-router-dom";
import moment from "moment";
import useCheckedDate from "../../../lms-shared/hooks/useCheckedDate";
import DynamicMessage from "../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../../lms-shared/models/DynamicMessageTypeEnum";

const SingleLesson = ({ dataLesson, studyGroupId }) => {
    const { applictionName } = useParams();
    const uiData = useSelector((state) => state.general.uiData);
    const [lessonesListType, setLessonesListType] = useState()

    const [messagePopup, setMessagePopup] = useState()
    const { direction, texts } = useSelector((state) => state.translate);
    const status = { fix: texts.fix, Started: texts.work, Submitted: "✔", Completed: "✔" }
    const homeUrl = useSelector(state => state.application.homeUrl);
    const navigate = useNavigate()
    const checkDate = useCheckedDate()

    useEffect(() => {
        if (uiData) {
            setLessonesListType(uiData[applictionName].lessonesListType)
        }
    }, [uiData])

    const getMark = () => {
        if (dataLesson && dataLesson.scoreAdditionalData && isJson(dataLesson.scoreAdditionalData)) {
            const res = JSON.parse(dataLesson.scoreAdditionalData)
            return res && res.ScoreType === "numScore" ? res.weightedScore : null
        }
        return null
    }


    const clickAssignmentHref = () => {
        if (dataLesson.activeFromDate && checkDate(new Date(dataLesson.activeFromDate), new Date(dataLesson.currentDate), new Date(dataLesson.ClientDate), new Date()) || dataLesson.active) {
            navigate(`${homeUrl}/${studyGroupId}/lesson/${dataLesson.id}`)
        }
        else {
            let contentText = ''
            if (dataLesson.activeFromDate)
                contentText = `${texts.messageLockedLesson} ${moment(dataLesson.activeFromDate).format("DD.MM.YY")}`
            setMessagePopup(<DynamicMessage
                type={DynamicMessageTypeEnum.Warn}
                title={texts.theLessonLocked}
                content={contentText}
                confirmText={texts.iUnderstand}
                confirmFunc={() => setMessagePopup(null)}
                showCancel={false} />)
        }
    }

    return (
        <React.Fragment>
            {dataLesson && <div className={`${classes[direction]} ${classes.AssignmentHref}`} onClick={clickAssignmentHref}>
                <div className={`${classes.AssignmentNum}`}>{dataLesson.index}</div>
                {lessonesListType&&
                <div className={`${classes.Assignment} ${classes[`Assignment${dataLesson.submissionStatus}`]} ${dataLesson.isLate ? classes.AssignmentLate : ''} ${dataLesson.lessonType === lessonesListType[2] ? classes.AssignmentContest : ''} ${(dataLesson.activeFromDate && new Date(dataLesson.activeFromDate) > new Date(dataLesson.currentDate) || !dataLesson.active && !dataLesson.activeFromDate) ? classes.LockedAssignment : ''}`}>
                    <div className={classes.Part1}>
                        <div className={classes.AssignmentName}>{dataLesson.name}</div>
                        <div className={`${classes[`AssignmentIDEIcon${dataLesson.ideId}`]}`}></div>
                    </div>
                    <div className={`${classes.AssignmentTags} ${classes[`AssignmentTags${dataLesson.index % 10}`]}`}>
                        <div className={classes.Part2}>
                            {dataLesson && <div className={`${classes.AssignmentTag} ${classes[`AssignmentTag_${dataLesson.submissionStatus}`]}`}>{status[dataLesson.submissionStatus]}</div>}
                            {getMark() && <div className={`${classes.AssignmentTag} ${classes[`AssignmentTag_mark`]}`}>{getMark()}</div>}
                            {dataLesson.isLate && <div className={`${classes.AssignmentTag} ${classes.AssignmentTag_late}`}>{texts.late}</div>}
                        </div>
                    </div>
                </div>}
            </div>}
            {messagePopup}
        </React.Fragment>

    )
}

export default SingleLesson